// PM Definisjoner
export const PM_PRIMAERBANK = 'PM_PRIMAERBANK';
export const PM_PRODUKTER = 'PM_PRODUKTER';
export const PM_PRODUKTER_ANNET = 'PM_PRODUKTER_ANNET';
export const PM_HVOR_KOMMER_PENGER_FRA = 'PM_HVOR_KOMMER_PENGER_FRA';
export const PM_HVOR_KOMMER_PENGER_FRA_TEXT = 'PM_HVOR_KOMMER_PENGER_FRA_TEXT';
export const PM_KONTANTER = 'PM_KONTANTER';
export const PM_KONTANTER_ARSAK = 'PM_KONTANTER_ARSAK';
export const PM_KONTANTER_ARLIG_BELOP_TOTALT = 'PM_KONTANTER_ARLIG_BELOP_TOTALT';
export const PM_KONTANTER_ANTALL_INNBETALINGER = 'PM_KONTANTER_ANTALL_INNBETALINGER';
export const PM_OVERFORE_UTLAND = 'PM_OVERFORE_UTLAND';
export const PM_OVERFORE_UTLAND_V2 = 'PM_OVERFORE_UTLAND_V2';
export const PM_OVERFORE_UTLAND_HVILKE_LAND = 'PM_OVERFORE_UTLAND_HVILKE_LAND';
export const PM_OVERFORE_UTLAND_ARLIG_BELOP_TOTALT = 'PM_OVERFORE_UTLAND_ARLIG_BELOP_TOTALT';
export const PM_OVERFORE_UTLAND_ANTALL_OVERFORINGER = 'PM_OVERFORE_UTLAND_ANTALL_OVERFORINGER';
export const PM_MOTTA_UTLAND = 'PM_MOTTA_UTLAND';
export const PM_MOTTA_UTLAND_V2 = 'PM_MOTTA_UTLAND_V2';
export const PM_MOTTA_UTLAND_HVILKE_LAND = 'PM_MOTTA_UTLAND_HVILKE_LAND';
export const PM_MOTTA_UTLAND_ARLIG_BELOP_TOTALT = 'PM_MOTTA_UTLAND_ARLIG_BELOP_TOTALT';
export const PM_MOTTA_UTLAND_ANTALL_OVERFORINGER = 'PM_MOTTA_UTLAND_ANTALL_OVERFORINGER';
export const PM_OPPBEVARE_FOR_ANDRE = 'PM_OPPBEVARE_FOR_ANDRE';
export const PM_OPPBEVARE_FOR_ANDRE_HVEM_EIER = 'PM_OPPBEVARE_FOR_ANDRE_HVEM_EIER';
export const PM_OPPBEVARE_FOR_ANDRE_HVEM_EIER_ID = 'PM_OPPBEVARE_FOR_ANDRE_HVEM_EIER_ID';
export const PM_OPPBEVARE_FOR_ANDRE_HVORFOR = 'PM_OPPBEVARE_FOR_ANDRE_HVORFOR';
export const PM_BOSTEDSLAND = 'PM_BOSTEDSLAND';
export const PM_FODELAND = 'PM_FODELAND';
export const PM_STATSBORGERSKAP = 'PM_STATSBORGERSKAP';
export const PM_STATSBORGERSKAP_SEKUNDART = 'PM_STATSBORGERSKAP_SEKUNDART';
export const PM_PEP = 'PM_PEP';
export const PM_PEP_HVEM = 'PM_PEP_HVEM';
export const PM_PEP_RELASJON = 'PM_PEP_RELASJON';
export const PM_FATCA = 'PM_FATCA';
export const PM_FATCA_V2 = 'PM_FATCA_V2';
export const PM_FATCA_TIN = 'PM_FATCA_TIN';
export const PM_FATCA_V2_TIN = 'PM_FATCA_V2_TIN';
export const PM_FATCA_IKKE_TIN = 'PM_FATCA_IKKE_TIN';
export const PM_FATCA_V2_IKKE_TIN = 'PM_FATCA_V2_IKKE_TIN';
export const PM_CRS = 'PM_CRS';
export const PM_CRS_V2 = 'PM_CRS_V2';
export const PM_CRS_DETALJER = 'PM_CRS_DETALJER';
export const PM_CRS_V2_DETALJER = 'PM_CRS_V2_DETALJER';

// BM Definisjoner
export const BM_BOSTEDSLAND = 'BM_BOSTEDSLAND';
export const BM_UTSLAG_LISTOSOK_AKTORER = 'BM_UTSLAG_LISTOSOK_AKTORER';
export const BM_EIES_AV_ANNEN = 'BM_EIES_AV_ANNEN';
export const BM_EIES_AV_ANNEN_DETALJER = 'BM_EIES_AV_ANNEN_DETALJER';
export const BM_SELSKAPSFORM = 'BM_SELSKAPSFORM';
export const BM_TYPE_BEDRIFT = 'BM_TYPE_BEDRIFT';
export const BM_STITET_AR = 'BM_STITET_AR';
export const BM_OMSETTNING = 'BM_OMSETTNING';
export const BM_REVISOR = 'BM_REVISOR';
export const BM_PRIMARBANK = 'BM_PRIMARBANK';
export const BM_PRODUKTER = 'BM_PRODUKTER';
export const BM_PRODUKTER_ANNET = 'BM_PRODUKTER_ANNET';
export const BM_MIDLENES_OPPRINNELSE = 'BM_MIDLENES_OPPRINNELSE';
export const BM_MIDLENES_OPPRINNELSE_ANNET = 'BM_MIDLENES_OPPRINNELSE_ANNET';
export const BM_INVESTERER_FOR_ANDRE = 'BM_INVESTERER_FOR_ANDRE';
export const BM_INVESTERER_FOR_ANDRE_HVEM = 'BM_INVESTERER_FOR_ANDRE_HVEM';
export const BM_KONTANTER = 'BM_KONTANTER';
export const BM_KONTANTER_ARSAK = 'BM_KONTANTER_ARSAK';
export const BM_KONTANTER_BELOP = 'BM_KONTANTER_BELOP';
export const BM_KONTANTER_ANTALL_INNBETALINGER = 'BM_KONTANTER_ANTALL_INNBETALINGER';
export const BM_OVERFORE_UTLAND = 'BM_OVERFORE_UTLAND';
export const BM_OVERFORE_UTLAND_V2 = 'BM_OVERFORE_UTLAND_V2';
export const BM_OVERFORE_UTLAND_HVILKE_LAND = 'BM_OVERFORE_UTLAND_HVILKE_LAND';
export const BM_OVERFORE_UTLAND_ARLIG_BELOP_TOTALT = 'BM_OVERFORE_UTLAND_ARLIG_BELOP_TOTALT';
export const BM_OVERFORE_UTLAND_ANTALL_OVERFORINGER = 'BM_OVERFORE_UTLAND_ANTALL_OVERFORINGER';
export const BM_MOTTA_UTLAND = 'BM_MOTTA_UTLAND';
export const BM_MOTTA_UTLAND_V2 = 'BM_MOTTA_UTLAND_V2';
export const BM_MOTTA_UTLAND_HVILKE_LAND_OG_HVORFOR = 'BM_MOTTA_UTLAND_HVILKE_LAND_OG_HVORFOR';
export const BM_MOTTA_UTLAND_ARLIG_BELOP_TOTALT = 'BM_MOTTA_UTLAND_ARLIG_BELOP_TOTALT';
export const BM_MOTTA_UTLAND_ANTALL_OVERFORINGER = 'BM_MOTTA_UTLAND_ANTALL_OVERFORINGER';
export const BM_OVERFORE_UTLAND_HOYRISIKO = 'BM_OVERFORE_UTLAND_HOYRISIKO';
export const BM_FATCA = 'BM_FATCA';
export const BM_FATCA_V2 = 'BM_FATCA_V2';
export const BM_FATCA_TIN = 'BM_FATCA_TIN';
export const BM_FATCA_V2_TIN = 'BM_FATCA_V2_TIN';
export const BM_FATCA_IKKE_TIN = 'BM_FATCA_IKKE_TIN';
export const BM_FATCA_V2_IKKE_TIN = 'BM_FATCA_V2_IKKE_TIN';
export const BM_CRS = 'BM_CRS';
export const BM_CRS_V2 = 'BM_CRS_V2';
export const BM_CRS_DETALJER = 'BM_CRS_DETALJER';
export const BM_CRS_V2_DETALJER = 'BM_CRS_V2_DETALJER';
export const BM_KONSESJONSPLIKTIG = 'BM_KONSESJONSPLIKTIG';
export const BM_KONTOHAVER_VERDIPAPIR = 'BM_KONTOHAVER_VERDIPAPIR';
export const BM_KONTOHAVER_OFFENTLIG = 'BM_KONTOHAVER_OFFENTLIG';
export const BM_KONTOHAVER_USA = 'BM_KONTOHAVER_USA';
export const BM_TYPE_KONTOHAVER = 'BM_TYPE_KONTOHAVER';
export const BM_FINANSIELL_INSTUTISJON = 'BM_FINANSIELL_INSTUTISJON';
export const BM_FINANSIELL_INSTUTISJON_GIN = 'BM_FINANSIELL_INSTUTISJON_GIN';
export const BM_FINANSIELL_INSTUTISJON_IKKE_GIN_ARSAK = 'BM_FINANSIELL_INSTUTISJON_IKKE_GIN_ARSAK';
export const BM_PASSIVT_SELSKAP = 'BM_PASSIVT_SELSKAP';
export const BM_RR_SKATTEMESSIG_HJEMMEHORENDE = 'BM_RR_SKATTEMESSIG_HJEMMEHORENDE';
export const BM_AKTOR_RR = 'BM_AKTOR_RR';
export const BM_AKTOR_RR_DETALJER = 'BM_AKTOR_RR_DETALJER';
export const BM_AKTOR_DAGLIG_LEDER = 'BM_AKTOR_DAGLIG_LEDER';
export const BM_AKTOR_STYRELEDER = 'BM_AKTOR_STYRELEDER';
export const BM_AKTOR_STYREMEDLEMMER = 'BM_AKTOR_STYREMEDLEMMER';
